import { StyleSheet } from 'react-native';
import theme from '../../common/theme';
import { ThemeColors } from '../../common/theme-colors';

export const getStyles = (colors: ThemeColors) =>
  StyleSheet.create({
    container: {
      flexDirection: 'row',
      alignItems: 'center',
      padding: 20,
      paddingRight: 14,
      borderWidth: 1,
      borderColor: colors.border,
      borderRadius: theme.radius.m,
      backgroundColor: colors.elevation0,
    },
    containerFocused: {
      borderColor: colors.primary,
    },
    inner: {
      flex: 1,
      fontSize: 18,
      lineHeight: 26,
      color: colors.text,
      fontVariant: ['tabular-nums'],
      fontFamily: theme.fonts.medium,
    },
    flag: {
      flexShrink: 0,
      marginRight: 12,
    },
    accessory: {
      flexShrink: 0,
      width: 26,
      height: 26,
      alignItems: 'center',
      justifyContent: 'center',
    },
  });

// react-native-web only — strips the default focus outline on the underlying
// <input>. Ignored on native platforms.
export const noFocusOutline = { outlineStyle: 'none' } as object;
